import {Types} from "@Common/types";
import {toJsDate} from "@Common/utils/date-object";

type ApiModel  = Types.Apis.Payloads.Next.Reporting.Transaction.Request;
type FormModel = Types.Xpresso.Account.Admin.Reporting.Transaction.FormModel;

export const mapAsApiRequest = (formValue:FormModel): ApiModel => (
    (Object.keys(formValue) as Array<keyof FormModel>)
        .filter(key => formValue[key]) // discard falsey values
        .reduce((apiValue, field) => ({
            ...apiValue,
            [field]: (
                field.endsWith("Date")
                    ? toJsDate(formValue[field] as Types.Common.Utils.DateObject.DateObject).toLocaleDateString("en-US")
                    : formValue[field]
            )
        }), {} as ApiModel)
);

